var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgOpera = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    id: "Landmark-Sydney-Opera-House--Streamline-Ultimate",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Landmark Sydney Opera House Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M1.81 12.66a0.24 0.24 0 0 1 0 0.26 0.48 0.48 0 0 0 -0.06 0.24v3.5a0.5 0.5 0 0 0 0.5 0.5h19.57a0.5 0.5 0 0 0 0.5 -0.5v-1.5a0.45 0.45 0 0 0 -0.15 -0.35 0.25 0.25 0 0 1 0 -0.33l1.53 -2.08a1.52 1.52 0 0 0 -1 -2.39 8.84 8.84 0 0 0 -3.63 0.19 0.24 0.24 0 0 1 -0.3 -0.17 9.09 9.09 0 0 0 -1.42 -2.95 11.75 11.75 0 0 0 -6.27 -4.19 1.49 1.49 0 0 0 -1.88 1.7l0.26 1.47a0.25 0.25 0 0 1 -0.36 0.27A10.7 10.7 0 0 0 5.37 5.2a1.5 1.5 0 0 0 -1.59 1.9l0.11 0.4a0.14 0.14 0 0 1 -0.15 0.18A4.71 4.71 0 0 0 1 8a1.49 1.49 0 0 0 -0.75 2.2Zm2.16 0a0.09 0.09 0 0 1 -0.07 0L2.25 10a0.25 0.25 0 0 1 0.18 -0.38 3.14 3.14 0 0 1 2.33 0.66l1.49 1.91a0.27 0.27 0 0 1 -0.18 0.47Zm4.77 0.07a0.48 0.48 0 0 0 -0.24 -0.07h-0.87a0.25 0.25 0 0 1 -0.24 -0.18L6 7.71a0.25 0.25 0 0 1 0.31 -0.31c2.32 0.6 3.46 1.74 3.81 2.6l1.44 3.8a0.25 0.25 0 0 1 -0.36 0.31Zm2.65 -7.23a0.25 0.25 0 0 1 0.34 -0.27A8.18 8.18 0 0 1 17 11a0.23 0.23 0 0 1 -0.11 0.25 6.61 6.61 0 0 0 -2.64 3.33 0.2 0.2 0 0 1 -0.18 0.12h-0.83a0.25 0.25 0 0 1 -0.25 -0.2Zm8.18 9.08a0.21 0.21 0 0 1 -0.16 0.08h-2.66a0.24 0.24 0 0 1 -0.2 -0.39 5.8 5.8 0 0 1 4.76 -2.36 0.25 0.25 0 0 1 0.21 0.4Z",
    fill: "currentColor",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.5 18.67h23s0.5 0 0.5 0.5v1.5s0 0.5 -0.5 0.5H0.5s-0.5 0 -0.5 -0.5v-1.5s0 -0.5 0.5 -0.5",
    fill: "currentColor",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgOpera);
export default ForwardRef;